<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">LED设备信息</div>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="getList">刷 新</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="deviceList"
              v-loading="loading"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="equipmentName"
                label="设备名称"
              ></el-table-column>
              <el-table-column
                prop="equipmentIp"
                label="设备IP"
              ></el-table-column>
              <el-table-column prop="onlineStatus" label="在线状态" width="140">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.onlineStatus == 1"
                    style="color: green;"
                    >在线</span
                  >
                  <span
                    v-else-if="scope.row.onlineStatus == 2"
                    style="color: red;"
                    >离线</span
                  >
                  <span v-else>未知</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import { listLedDevice } from "@/api/src/led";
export default {
  name: "LedDeviceInfoView",
  controller: "UI",
  action: "LedDeviceInfoView",
  data() {
    return {
      loading: false,
      deviceList: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      listLedDevice()
        .then((res) => {
          // 后端返回 R<List<...>>，统一从 data/rows 中取
          this.deviceList = res.data || res.rows || [];
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
